export enum PaymentEvents {
  PayPal = 'pay_paypal',
  CreditCard = 'pay_creditcard',
  Crypto = 'pay_crypto',
  ApplePay = 'pay_applepay',
  StripeCard = 'pay_stripe_card',
}
